import React from "react";
import cn from "classnames";
import contact from "../../assets/images/contact.png";
import ReservationForm from "./ReservationForm";

const ReservationBlock = ({ light, omits }) => {
  return (
    <section className={cn("contact-area", "pb-70", "pt-70", { "bg-light": light })}>
      <div className="container">
        <div className="section-title">
          <h2>预约产品演示</h2>
          <p>我们将在24小时内联系您</p>
        </div>

        <div className="row align-items-center justify-content-around">
          <div className="col-lg-4 col-md-12">
            <div className="contact-image">
              <img src={contact} alt="contact" />
            </div>
          </div>

          <div className="col-lg-7 col-md-12">
            <div className="contact-form rounded">
              <ReservationForm omits={omits} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReservationBlock;
